import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deletePreventiveTask } from '../../../../actions/task-schedule/PreventiveTask';

const DeletePreventiveTaskButton = ({
  preventiveTaskId,
  dispatchDeletePreventiveTask,
}) => {
  const [showModal, setShowModal] = React.useState(false);
  const onClickDelete = () => dispatchDeletePreventiveTask(preventiveTaskId);
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <Fragment>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal}>
        Eliminar
      </Button>
    </Fragment>
  );
};

DeletePreventiveTaskButton.propTypes = {
  preventiveTaskId: PropTypes.number.isRequired,
  dispatchDeletePreventiveTask: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeletePreventiveTask: deletePreventiveTask,
};

export default connect(null, mapDispatchToProps)(DeletePreventiveTaskButton);
